module.exports = __webpack_public_path__ + "static/media/home_new.5c073456.png";